/**
 * File inspection helpers for the Bulk Upload screen.
 */

import {
  BYTES_PER_KB,
  BYTES_PER_MB,
  FILE_CONSTRAINTS,
} from "../Json/BulkUploadConfigJson";
import { BULK_UPLOAD_MESSAGES } from "../Json/BulkUploadMessages";

/** @returns {string} The lower-cased extension, including the leading dot. */
export const getFileExtension = (filename) => {
  const parts = String(filename || "").split(".");
  return parts.length > 1 ? `.${parts.pop().toLowerCase()}` : "";
};

/** @returns {string} A human readable size, e.g. "1.4 MB". */
export const formatFileSize = (bytes) => {
  const size = Number(bytes) || 0;

  if (size < BYTES_PER_KB) return `${size} B`;
  if (size < BYTES_PER_MB) return `${(size / BYTES_PER_KB).toFixed(1)} KB`;
  return `${(size / BYTES_PER_MB).toFixed(2)} MB`;
};

/**
 * Checks a file against FILE_CONSTRAINTS before it leaves the browser.
 *
 * @returns {string|null} A message describing the problem, or null if valid.
 */
export const validateFile = (file) => {
  const { validation } = BULK_UPLOAD_MESSAGES;

  if (!file) return validation.noFile;

  if (!FILE_CONSTRAINTS.acceptedExtensions.includes(getFileExtension(file.name))) {
    return validation.unsupportedType;
  }

  if (file.size === 0) return validation.emptyFile;

  if (file.size > FILE_CONSTRAINTS.maxSizeMb * BYTES_PER_MB) {
    return validation.tooLarge;
  }

  return null;
};
